/* eslint-disable no-restricted-globals */
import { useMemo } from 'react';

import useForm from '../utils/useForm';

const useScheduledPaymentForm = (onSubmit, values, disabled) => {
  const fields = useMemo(
    () => [
      {
        title: '',
        fields: [
          {
            title: 'Date',
            name: 'date',
            type: 'date',
            required: true,
            disablePastDates: true,
            readOnly: disabled,
          },
          {
            title: 'Amount',
            name: 'amount',
            type: 'currency',
            required: true,
            readOnly: disabled,
          },
          {
            title: 'Additional principal',
            name: 'amount_to_principal',
            type: 'currency',
            required: true,
            readOnly: disabled,
          },
        ],
      },
    ],
    [disabled]
  );

  return useForm({ fields, onSubmit, values });
};

export default useScheduledPaymentForm;
